// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ChannelIcon[data-v-16d49be4]{min-width:1em}\n", ""]);
// Exports
module.exports = exports;
